const debounce = require('utilities/debounce');

/**
 * Scrolls until the position of a given element
 * @param  {HTMLElement} parent The container of the element to scroll to
 * @param  {HTMLElement} element The element to scroll to
 * @param  {Number} duration  The duration of the scrolling animation
 * @param  {Number} currentTime The progress time in the scrolling animation
 */
const scrollTo = (parent, element, duration = 500, currentTime = 0) => {
    if (!parent || !element) {
        return;
    }

    const toPosition = element.offsetTop - 10;

    if (duration === 0) {
        parent.scrollTop = toPosition;
    } else {
        if (currentTime >= duration) {
            return;
        }
        let progress = currentTime / duration * Math.PI / 2;
        let position = toPosition * (Math.sin(progress));

        setTimeout(() => {
            parent.scrollTop = position;
            this.scrollTo(parent, element, duration, currentTime + 10);
        }, 10);
    }
};

const on = (element = window, callback, isDebounceable = true) => {
    const onScroll = isDebounceable ? debounce(callback, 10) : callback;
    element.addEventListener('scroll', onScroll, false);
    return onScroll;
};

const off = (element = window, callback) => {
    element.removeEventListener('scroll', callback);
};

const scrollToTop = () => {
    window.scrollTo(0, 0);
};

const preventBackgroundScroll = (on) => {
    if (on) {
        document.querySelector('body').classList.add('no-scroll');
    } else {
        document.querySelector('body').classList.remove('no-scroll');
    }
};

module.exports = {
    scrollTo,
    on,
    off,
    scrollToTop,
    preventBackgroundScroll
};
